import { openPanel } from '@/shared/panelStack.js';
import BasketPanel from '@/components/BasketPanel.vue';

// Opening the basket, in one place. The basket store deliberately owns no view state (see
// its own header comment), and app.js has no business importing a Vue component, so the one
// thing both need to know - which component the basket panel is, and what it is titled -
// lives here.
export function openBasketPanel() {
    openPanel({ component: BasketPanel, title: 'Your Basket' });
}
